module.exports = __webpack_public_path__ + "static/media/mercado-modelo-uniforme-polo-personalizado-768x591.bcf804d4.jpg";